import axiosClient from "../../../../axiosClient"

export default async () => {
    const result = await axiosClient.get(`/pre-checks`)
    return result.data
}
